<section class="add-card-dialog">
    <header class="add-card-dialog__header">
        <div>
            <span>Método de pago</span>
            <h1 mat-dialog-title>Agregar tarjeta</h1>
        </div>
        <mat-icon>credit_card</mat-icon>
    </header>

    <div mat-dialog-content class="add-card-dialog__content">
        <form [formGroup]="cardFG" id="cardForm" class="add-card-form">
            <div *ngIf="service.user.account_status=='plan_unpaid'" class="plan-warning">
                Es necesario agregar una tarjeta para poder activar el plan requerido.
            </div>

            <section class="add-card-form__section">
                <h2>Datos de la tarjeta</h2>
                <div class="add-card-form__grid">
                    <mat-form-field appearance="outline" class="field-span-12">
                        <input matInput formControlName="name" required placeholder="Nombre en la Tarjeta">
                        <div
                            *ngIf="
                            cardFG.controls['name'].hasError('minlength') ||
                            cardFG.controls['name'].hasError('required') &&
                            cardFG.controls['name'].touched"
                            class="error-modal">
                            El nombre debe tener mínimo 3 letras.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-8">
                        <input matInput formControlName="number" required placeholder="Número de Tarjeta" min="16" max="16">
                        <div
                            *ngIf="
                            cardFG.controls['number'].hasError('minlength') ||
                            cardFG.controls['number'].hasError('maxlength') ||
                            cardFG.controls['number'].hasError('pattern') ||
                            cardFG.controls['number'].hasError('required') &&
                            cardFG.controls['number'].touched"
                            class="error-modal">
                            La tarjeta debe tener 16 dígitos.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-4">
                        <input matInput formControlName="cvc" required placeholder="CVV">
                        <div
                            *ngIf="
                            cardFG.controls['cvc'].hasError('minlength') ||
                            cardFG.controls['cvc'].hasError('maxlength') ||
                            cardFG.controls['cvc'].hasError('pattern') ||
                            cardFG.controls['cvc'].hasError('required') &&
                            cardFG.controls['cvc'].touched"
                            class="error-modal">
                            El CVC debe tener 3 o 4 dígitos.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-4">
                        <input matInput formControlName="exp_month" required placeholder="MM">
                        <div
                            *ngIf="
                            cardFG.controls['exp_month'].hasError('minlength') ||
                            cardFG.controls['exp_month'].hasError('maxlength') ||
                            cardFG.controls['exp_month'].hasError('pattern') ||
                            cardFG.controls['exp_month'].hasError('required') &&
                            cardFG.controls['exp_month'].touched"
                            class="error-modal">
                            El mes de expiración debe tener dos dígitos.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-4">
                        <input matInput formControlName="exp_year" required placeholder="AA">
                        <div
                            *ngIf="
                            cardFG.controls['exp_year'].hasError('minlength') ||
                            cardFG.controls['exp_year'].hasError('maxlength') ||
                            cardFG.controls['exp_year'].hasError('pattern') ||
                            cardFG.controls['exp_year'].hasError('required') &&
                            cardFG.controls['exp_year'].touched"
                            class="error-modal">
                            El año de expiración debe tener dos dígitos.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-4">
                        <input matInput formControlName="zip" required placeholder="Código postal">
                        <div
                            *ngIf="
                            cardFG.controls['zip'].hasError('minlength') ||
                            cardFG.controls['zip'].hasError('maxlength') ||
                            cardFG.controls['zip'].hasError('pattern') ||
                            cardFG.controls['zip'].hasError('required') &&
                            cardFG.controls['zip'].touched"
                            class="error-modal">
                            El código postal debe tener 5 dígitos.
                        </div>
                    </mat-form-field>
                </div>
            </section>

            <section class="add-card-form__section">
                <h2>Dirección de facturación</h2>
                <div class="add-card-form__grid">
                    <mat-form-field appearance="outline" class="field-span-12">
                        <input matInput formControlName="street1" required placeholder="Dirección">
                        <div
                            *ngIf="
                            cardFG.controls['street1'].hasError('minlength') ||
                            cardFG.controls['street1'].hasError('required') &&
                            cardFG.controls['street1'].touched"
                            class="error-modal">
                            La dirección debe tener mínimo 3 letras.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-12">
                        <input matInput formControlName="street2" required placeholder="Colonia">
                        <div
                            *ngIf="
                            cardFG.controls['street2'].hasError('minlength') ||
                            cardFG.controls['street2'].hasError('required') &&
                            cardFG.controls['street2'].touched"
                            class="error-modal">
                            La colonia debe tener mínimo 3 letras.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-4">
                        <input matInput formControlName="city" required placeholder="Ciudad">
                        <div
                            *ngIf="
                            cardFG.controls['city'].hasError('minlength') ||
                            cardFG.controls['city'].hasError('required') &&
                            cardFG.controls['city'].touched"
                            class="error-modal">
                            La ciudad debe tener mínimo 3 letras.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-4">
                        <input matInput formControlName="state" required placeholder="Estado">
                        <div
                            *ngIf="
                            cardFG.controls['state'].hasError('minlength') ||
                            cardFG.controls['state'].hasError('required') &&
                            cardFG.controls['state'].touched"
                            class="error-modal">
                            El estado debe tener mínimo 3 letras.
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field-span-4">
                        <input matInput formControlName="country" required placeholder="País">
                        <div
                            *ngIf="
                            cardFG.controls['country'].hasError('minlength') ||
                            cardFG.controls['country'].hasError('required') &&
                            cardFG.controls['country'].touched"
                            class="error-modal">
                            El país debe tener mínimo 3 letras.
                        </div>
                    </mat-form-field>
                </div>
            </section>
        </form>
    </div>

    <footer class="add-card-dialog__footer">
        <div class="add-card-dialog__brands">
            <span>Se acepta</span>
            <div>
                <img src="../../../assets/img/mastercard.jpg" alt="Mastercard">
                <img src="../../../assets/img/amex.png" alt="American Express">
                <img src="../../../assets/img/visa.svg" alt="Visa">
            </div>
        </div>

        <img class="add-card-dialog__openpay" src="../../../assets/img/LogotipoOpenpay-01.jpg" alt="OpenPay logo">

        <div mat-dialog-actions class="add-card-dialog__actions">
            <button mat-button type="button" (click)="onNoClick()">Cancelar</button>
            <button mat-flat-button type="button" [disabled]="cardFG.invalid" (click)="saveCard()">Guardar</button>
        </div>
    </footer>

    <div class="loading" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
    </div>
</section>
